import Swiper from 'swiper'
import { A11y, Navigation } from 'swiper/modules'

document.querySelectorAll('.element-photogalleryslider').forEach((el) => {
  const container = el.querySelector('.swiper')
  const numSlides = el.querySelectorAll('.swiper-slide').length

  new Swiper(container, {
    modules: [A11y, Navigation],
    slidesPerView: 'auto',
    spaceBetween: 24,
    speed: 500,
    navigation: {
      nextEl: el.querySelector('.slider-button-next'),
      prevEl: el.querySelector('.slider-button-prev'),
    },
    loop: numSlides > 2,
    centeredSlides: numSlides > 2,
    centerInsufficientSlides: true,
    breakpoints: {
      1280: {
        slidesPerView: 'auto',
        spaceBetween: 30,
      },
    },
  })
})
